import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeDechetRwdto } from 'src/api/models/type-dechet-rwdto';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-dechet-rw',
  templateUrl: './type-dechet-rw.component.html',
  styleUrls: ['./type-dechet-rw.component.css']
})
export class TypeDechetRWComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.typesDechetsRW$) typesDechetsRW$: Observable<TypeDechetRwdto[]>;
  
  @Input('typeDechetRWId') public typeDechetRWId: number;

  TypeInComponent: TypeDechetRwdto;

  t: Subscription;
  
  constructor() {}

  ngOnInit() {
    this.t = this.typesDechetsRW$.subscribe(res => {
      if (res != null) {
        let types = res.filter(t => t.Id == this.typeDechetRWId);
        this.TypeInComponent = types.length == 1 ? types[0] : { Code: null, Description: null };
      }
    });
  }

  ngOnDestroy() {
    this.t?.unsubscribe();
  }

}
